import { AddRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Chip } from '@components';
import { useTranslation } from 'next-i18next';

import React from 'react';

const Prices = ({ onOpenAddToCartDrawer, tickets }) => {
  const { t } = useTranslation();
  return (
    <div className="flex justify-center flex-col items-center px-4">
      <Chip text={t('drawers.book_product.steps.tickets.name')} />

      <div className="w-full ">
        {tickets?.length > 0 &&
          tickets.map((ticket) => (
            <div
              key={ticket.id}
              className="w-full body flex justify-between"
            >
              <p className="w-full">{ticket.name}</p>
              <p className="flex space-x-2">
                <span>
                  &#x20AC;
                  {ticket?.price_sale}
                </span>
              </p>
            </div>
          ))}
      </div>
      <Button
        onClick={(e) => {
          onOpenAddToCartDrawer(e);
        }}
        variant="contained"
        dense
        sx={{ backgroundColor: '#da5f06  !important' }}
      >
        <AddRounded className="mr-2" />
        <span className="uppercase ">{t('buttons.buy')}</span>
      </Button>
    </div>
  );
};

export default Prices;
